module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_AlignHorizontalCenter_16"],"path":[{"$":{"d":"M16,7H14V4H9V7H7V2H2V7H0V9H2v5H7V9H9v3h5V9h2ZM6,13H3V3H6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_AlignHorizontalCenter_16.svg
// module id = WzYN
// module chunks = 1